import { createSlice } from "@reduxjs/toolkit";
import { getCookie } from "../utility/utility";

const initialState = {
  user: null,
  hasToken: !!getCookie("twitchUserSession"),
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      state.user = action.payload;
      state.hasToken = true;
    },
    logout: (state) => {
      state.user = null;
      state.hasToken = false;
    },
    updateUser: (state, action) => {
      if (state.user) {
        state.user = { ...state.user, ...action.payload };
      }
    },
  },
});

export const { setCredentials, logout, updateUser } = userSlice.actions;
export default userSlice.reducer;
